import support from './support';

export default class SwipeIndicator {

    constructor(options) {
        
        options = Object.assign({}, {
            elem: document,
            callback: function(){},
            maxDelta: 50,
            preventMouse: false
        }, options)

        this.elem       = options.elem;
        this.callback = options.callback;
        this.maxDelta = options.maxDelta;
        this.direction = options.direction || 'y';
        this.preventMouse = options.preventMouse;

        this._onPointerDown = this._onPointerDown.bind(this);
        this._onPointerMove = this._onPointerMove.bind(this);
        this._onPointerUp   = this._onPointerUp.bind(this);


        if (support.multipointerdown &&
            support.multipointerdown.length > 0) {
            for (let i=0; i<support.multipointerdown.length; i++) {
                this.elem.addEventListener(support.multipointerdown[i], this._onPointerDown,  { passive: false } );
                document.addEventListener(support.multipointermove[i], this._onPointerMove,  { passive: false } );
                document.addEventListener(support.multipointerup[i], this._onPointerUp,  { passive: false } );
            }
        }
        else {
            this.elem.addEventListener(support.pointerdown, this._onPointerDown, support.touch ? { passive: false } : false);
            document.addEventListener(support.pointermove, this._onPointerMove, support.touch ? { passive: false } : false);
            document.addEventListener(support.pointerup, this._onPointerUp, support.touch ? { passive: false } : false);
        }
        

        this._isPointerDown = false;
        this._enabled       = true;
    }   

    disable() {
        this._enabled = false;
    }

    enable() {
        this._enabled = true;
    }

    turnOff() {
        this.disable()
    }

    turnOn() {
        this.enable()
    }

    destroy() {
        
        if (support.multipointerdown &&
            support.multipointerdown.length > 0) {
            for (let i=0; i<support.multipointerdown.length; i++) {
                this.elem.removeEventListener(support.multipointerdown[i], this._onPointerDown);
                document.removeEventListener(support.multipointermove[i], this._onPointerMove);
                document.removeEventListener(support.multipointerup[i], this._onPointerUp);
            }
        }
        else {
            this.elem.removeEventListener(support.pointerdown, this._onPointerDown);
            document.removeEventListener(support.pointermove, this._onPointerMove);
            document.removeEventListener(support.pointerup, this._onPointerUp);
        }

    }
    
    _onPointerDown(event) {
        if (!this._enabled || this._isPointerDown) {
            return;
        }
        this._isPointerDown = true;
        this._moveDeltaX = 0;
        this._moveDeltaY = 0;
        this._pointerStartEvent = support.touch && event.type != 'mousedown' ? (event.touches[0] || event.changedTouches[0]) : event;
    }

    _onPointerMove(event) {

        if (!this._enabled) {
            return;
        }

        if (this._isPointerDown) {
            if (this.preventMouse) {
                // event.preventDefault();
                // event.stopPropagation();
            }
            let _event = support.touch && event.type != 'mousemove' ? (event.touches[0] || event.changedTouches[0]) : event;
            let pageY = _event.pageY;// - (window.pageYOffset || document.documentElement.scrollTop);
            let pageX = _event.pageX;// - (window.pageXOffset || document.documentElement.scrollLeft);
            this._moveDeltaX = (pageX - this._pointerStartEvent.pageX);
            this._moveDeltaY = (pageY - this._pointerStartEvent.pageY);
        }
    }

    _onPointerUp(e) {
        if (this._enabled) {
            if (this.direction=='y' || this.direction=='xy') {
                if (Math.abs(this._moveDeltaY) > this.maxDelta) {
                    this.callback( {direction: this._moveDeltaY>0?'up':'down'} )
                } 
            }
            else if (this.direction=='x' || this.direction=='xy') {
                if (Math.abs(this._moveDeltaX) > this.maxDelta) {
                    this.callback( {direction: this._moveDeltaX>0?'left':'right'} )
                } 
            }
            
        }
        this._isPointerDown = false;
    }
}